import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
  IExportScheduleContentData,
  IExportScheduleData,
  IExportSchedulesDataState,
} from './ExportSchedulesModels'
import { appApiEndPoints } from '../../constants/ApiEndPoints'
import ApiService from '../../services/ApiService'

const initialState: IExportSchedulesDataState = {
  schedulesData: [],
  status: 'idle',
  error: null,
  contentsData: [],
  contentsError: null,
  contentsStatus: 'idle',
  tableFilters: {
    FileType: 'Schedules',
    DataCenter: 'North Carolina',
  },
  tablePagination: {
    PageNumber: 1,
    RecordsPerPage: 25,
  },
  tableSort: {
    SortBy: null,
    SortOrder: null,
  },
}

export const fetchData = createAsyncThunk('export/fetchSchedulesData', async (params) => {
  const response = await ApiService.getData(appApiEndPoints.exportSchedulesDataURL, params)
  return response.data
})
export const fetchExportScheduleContentData = createAsyncThunk(
  'export/fetchExportScheduleContentData',
  async (params) => {
    const response = await ApiService.getData(appApiEndPoints.exportScheduleContentDataURL, params)
    return response.data
  },
)

export const ExportSchedulesDataSlice = createSlice({
  name: 'exportSchedulesData',
  initialState,
  reducers: {
    setError: (state, action) => {
      state.error = action?.payload
    },
    setContentsError: (state, action) => {
      state.contentsError = action?.payload
    },
    updateFilters: (state, action) => {
      state.tableFilters = action?.payload
    },
    updatePagination: (state, action) => {
      state.tablePagination = action?.payload
    },
    updateSort: (state, action) => {
      state.tableSort = action?.payload
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchData.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.schedulesData = action?.payload as IExportScheduleData[]
      })
      .addCase(fetchData.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action?.error?.message || 'Failed to fetch schedules data'
      })
      .addCase(fetchExportScheduleContentData.pending, (state) => {
        state.contentsStatus = 'loading'
      })
      .addCase(fetchExportScheduleContentData.fulfilled, (state, action) => {
        state.contentsStatus = 'succeeded'
        state.contentsData = action?.payload as IExportScheduleContentData[]
      })
      .addCase(fetchExportScheduleContentData.rejected, (state, action) => {
        state.contentsStatus = 'failed'
        state.contentsError =
          action?.error?.message || 'Failed to fetch export schedule content data'
      })
  },
})
export const { setError, updateFilters, updatePagination, updateSort, setContentsError } =
  ExportSchedulesDataSlice.actions
export default ExportSchedulesDataSlice.reducer
